import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-reading-basis-page',
  imports: [RidDemoPage, RidButton],
  templateUrl: './reading-basis-page.html',
})
export class ReadingBasisPage {
  protected readonly $router = inject(Router);
}
